import { Box, Grid } from '@mui/material';
import './cancel-main.styles.scss';
import Button from '../../../components/button/button.component';
import { Link } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import Checkbox from '../../../components/checkbox/checkbox.component';
import { CancelContext } from '../../../contexts/cancellation.context';
import { addError, removeErrorConfirm } from '../../../utils/generaFunctions';

const CancelMain = () => {
    const {userInfo, loading} = useContext(CancelContext);
    const [choice, setChoice] = useState(null);
    const [pauseText, setPauseText] = useState("");
    const options = [
        {text:"pause subscription", desc:`Take a break for ${pauseText}`, value:"pause"}, 
        {text:"Customize themes", desc:"Choose specific themes you’d like to receive", value:"customize"},
        {text:"I want to cancel my subscription", value:"offer"}
    ];
    useEffect(()=>{
        removeErrorConfirm();
    },[choice]);
    useEffect(()=>{
        if(userInfo.plan_code && userInfo.plan_code.search("-a") > 0){
            setPauseText("2, 4 or 6 weeks");
        } else if(userInfo.plan_code && userInfo.plan_code.search("-s") > 0){
            setPauseText("1, 2 or 3 months");
        } else if(userInfo.plan_code && userInfo.plan_code.search("-e") > 0){
            setPauseText("2, 4 or 6 months");
        } else if(userInfo.plan_code && userInfo.plan_code.search("-q") > 0){
            setPauseText("3, 6 or 9 months");
        } 
    },[userInfo.plan_code])

    return (
        <Grid container className='main-container' >
            <Grid container item className='flex-vertical'>
                <div>
                    <Grid item className='title'>
                        <h1>You've got options</h1>
                    </Grid>
                    <Grid item className='desc'>
                        {loading?<div className='box-placeholder text'></div>:userInfo.name.split(" ")[0]}, take a look at features that have been popular with other subscribers.
                    </Grid>
                </div>
                <Grid item id='option-container'>
                    {options.map((option, index) => {
                        return (
                            <Box key={`cancel-option${index}`} className={`box ${choice === index? "selected":"not-selected"}`} onClick={()=>{setChoice(index);}}>
                                <div className='flex-vertical'>
                                    <div className='m-vertical'>
                                        <div className='small-header'>{option.text}</div>
                                        <img alt={`img-${index}`} src={option.image} style={{display:option.image?"":"none"}}></img>
                                    </div>
                                    <div className='info-label-roman' style={{display:option.desc?"":"none"}}>{option.desc}</div>
                                </div>
                                <Checkbox key={"checkbox"+index} checked={choice===index} large={"true"}/>
                            </Box>
                        )
                    })}
                </Grid>
                <Grid item id='button-container'>
                    <Link className={`button-link`} to={options[choice]? options[choice].value + window.location.search:""} onClick={()=>{addError(document.getElementById('option-container'), 'Select one of the options above first and then click continue')}}><Button text="CONTINUE"></Button></Link>
                    <Link className={`button-link`} to={"keep"+window.location.search}><Button className="btn-reverse" text={"Keep my subscription as-is"}/></Link>
                </Grid>
                </Grid>
        </Grid>
    )
}

export default CancelMain;